module.exports = __webpack_public_path__ + "img/talento.9f2da865.jpeg";